import { Component, OnInit, Input } from '@angular/core';
import { Submission } from "../../models/submission";
import { SubmissionService } from "../../submission.service";
import { Observable } from "rxjs/Observable";

@Component({
  selector: 'other-posts',
  templateUrl: './other-posts.component.html',
  styleUrls: ['./other-posts.component.css']
})
export class OtherPostsComponent implements OnInit {
  @Input() author: string;
  @Input() id: string;
  posts: Submission[];
  otherPosts: Observable<Submission[]>;

  constructor(private service : SubmissionService) {} 

  ngOnInit() {

    this.otherPosts = this.service.getOtherSubmissions(this.author);
    this.otherPosts.subscribe(posts => this.setupOtherPosts(posts));
  }

  setupOtherPosts(subs: Submission[]) {
    for (let i=0;i<subs.length;i++){
      if(subs[i].id === this.id){
        subs.splice(i,1);
        break;
      }
    }
    if(subs.length>4){
      subs.pop();
    }
    this.posts = subs;
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/app/submission-details/other-posts/other-posts.component.ts